import $api from "../http"
export default class ExpayService {
    static create_invoice(sub_token,amount,token="CARDRUBP2P"){
        return $api.post("/create_invoiceEXPAY",{token,amount,sub_token})
    }
    static create_payout(sub_token,receiver,amount,bank_name=null,token="CARDRUBP2P"){
        return $api.post("/create_payoutEXPAY",{sub_token,receiver,bank_name,amount,token})
    }
}